import { Modal, Form, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faPen } from "@fortawesome/free-solid-svg-icons";

const JobFormModal = ({
    show,
    title,
    buttonText,
    loading,
    form,
    onClose,
    onSubmit,
    onChange,

    cities,

    industries,
    industrySubcategories,
    onIndustryChange,

    functions,
    functionSubcategories,
    ugDegrees,
    pgDegrees,
    doctorateInput,
    setDoctorateInput,
    onFunctionChange,
}) => {
    return (
        <Modal
            show={show}
            onHide={onClose}
            centered
            className="post-job-modal"
        >
            <Modal.Header closeButton className="post-job-modal-header">
                <Modal.Title className="post-job-modal-title">
                    {title}
                </Modal.Title>
            </Modal.Header>

            <Form onSubmit={onSubmit}>
                <Modal.Body className="post-job-modal-body">

                    <Form.Group className="mb-3">
                        <Form.Label className="post-job-label">
                            Job Title <span className="required-star">*</span>
                        </Form.Label>

                        <Form.Control
                            type="text"
                            name="title"
                            value={form.title}
                            onChange={onChange}
                            placeholder="Enter job title"
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>
                            Location <span className="required-star">*</span>
                        </Form.Label>

                        <Form.Select
                            name="location"
                            value={form.location}
                            onChange={onChange}
                        >
                            <option value="">Select Location</option>

                            {cities.map(city => (
                                <option key={city} value={city}>
                                    {city}
                                </option>
                            ))}
                        </Form.Select>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>
                            Function <span className="required-star">*</span>
                        </Form.Label>

                        <Form.Select
                            value={form.functionId}
                            onChange={onFunctionChange}
                        >
                            <option value="">Select Function</option>

                            {functions.map(item => (
                                <option key={item.id} value={item.id}>
                                    {item.function}
                                </option>
                            ))}
                        </Form.Select>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>
                            Function Subcategory
                        </Form.Label>

                        <Form.Select
                            value={form.functionSubcategory}
                            onChange={(e) =>
                                onChange({
                                    target: {
                                        name: "functionSubcategory",
                                        value: e.target.value,
                                    },
                                })
                            }
                        >
                            <option value="">
                                Select Function Subcategory
                            </option>

                            {functionSubcategories.map(item => (
                                <option key={item.id} value={item.subcategory}>
                                    {item.subcategory}
                                </option>
                            ))}
                        </Form.Select>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>
                            Industry
                        </Form.Label>

                        <Form.Select
                            value={form.industryId}
                            onChange={onIndustryChange}
                        >
                            <option value="">Select Industry</option>

                            {industries.map(item => (
                                <option key={item.id} value={item.id}>
                                    {item.industrySector}
                                </option>
                            ))}
                        </Form.Select>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>
                            Industry Subcategory
                        </Form.Label>

                        <Form.Select
                            value={form.industrySubcategory}
                            onChange={(e) =>
                                onChange({
                                    target: {
                                        name: "industrySubcategory",
                                        value: e.target.value,
                                    },
                                })
                            }
                        >
                            <option value="">
                                Select Industry Subcategory
                            </option>

                            {industrySubcategories.map(item => (
                                <option key={item.id} value={item.subcategory}>
                                    {item.subcategory}
                                </option>
                            ))}
                        </Form.Select>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>
                            Experience <span className="required-star">*</span>
                        </Form.Label>

                        <Form.Control
                            type="number"
                            min={0}
                            name="experience"
                            value={form.experience}
                            onChange={onChange}
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>
                            Qualification <span className="required-star">*</span>
                        </Form.Label>

                        {/* Bachelor's */}
                        <Form.Check
                            className="mb-2"
                            type="checkbox"
                            id="hasGraduationDegree"
                            label="Bachelor's"
                            checked={form.hasGraduationDegree === "YES"}
                            onChange={(e) =>
                                onChange({
                                    target: {
                                        name: "hasGraduationDegree",
                                        value: e.target.checked ? "YES" : "NO",
                                    },
                                })
                            }
                        />

                        {form.hasGraduationDegree === "YES" && (
                            <div className="ms-4 mb-3">
                                <Form.Group className="mb-2">
                                    <Form.Label>Select UG Degrees</Form.Label>

                                    <Form.Select
                                        onChange={(e) => {
                                            const degree = e.target.value;

                                            if (
                                                degree &&
                                                !form.graduationDegrees.includes(degree)
                                            ) {
                                                onChange({
                                                    target: {
                                                        name: "graduationDegrees",
                                                        value: [
                                                            ...form.graduationDegrees,
                                                            degree,
                                                        ],
                                                    },
                                                });
                                            }

                                            e.target.value = "";
                                        }}
                                    >
                                        <option value="">Select Degree</option>

                                        {ugDegrees
                                            .filter(
                                                degree =>
                                                    !form.graduationDegrees.includes(degree)
                                            )
                                            .map(degree => (
                                                <option key={degree} value={degree}>
                                                    {degree}
                                                </option>
                                            ))}
                                    </Form.Select>
                                </Form.Group>

                                {/* <Form.Control
                                    readOnly
                                    value={form.graduationDegrees.join(", ")}
                                    placeholder="Selected UG Degrees"
                                /> */}
                                {form.graduationDegrees.length > 0 && (
                                    <div className="mt-2 d-flex flex-wrap gap-2">
                                        {form.graduationDegrees.map((degree, index) => (
                                            <span
                                                key={index}
                                                className="badge bg-secondary d-flex align-items-center"
                                            >
                                                {degree}

                                                <button
                                                    type="button"
                                                    className="btn-close btn-close-white ms-2"
                                                    style={{ fontSize: "10px" }}
                                                    onClick={() =>
                                                        onChange({
                                                            target: {
                                                                name: "graduationDegrees",
                                                                value: form.graduationDegrees.filter(
                                                                    (_, i) => i !== index
                                                                ),
                                                            },
                                                        })
                                                    }
                                                />
                                            </span>
                                        ))}
                                    </div>
                                )}
                            </div>
                        )}

                        {/* Post Graduation */}
                        <Form.Check
                            className="mb-2"
                            type="checkbox"
                            id="hasPg"
                            label="Post Graduation"
                            checked={form.hasPg === "YES"}
                            onChange={(e) =>
                                onChange({
                                    target: {
                                        name: "hasPg",
                                        value: e.target.checked ? "YES" : "NO",
                                    },
                                })
                            }
                        />

                        {form.hasPg === "YES" && (
                            <div className="ms-4 mb-3">
                                <Form.Group className="mb-2">
                                    <Form.Label>Select PG Degrees</Form.Label>

                                    <Form.Select
                                        onChange={(e) => {
                                            const degree = e.target.value;

                                            if (
                                                degree &&
                                                !form.pgDegrees.includes(degree)
                                            ) {
                                                onChange({
                                                    target: {
                                                        name: "pgDegrees",
                                                        value: [
                                                            ...form.pgDegrees,
                                                            degree,
                                                        ],
                                                    },
                                                });
                                            }

                                            e.target.value = "";
                                        }}
                                    >
                                        <option value="">Select Degree</option>

                                        {pgDegrees
                                            .filter(
                                                degree =>
                                                    !form.pgDegrees.includes(degree)
                                            )
                                            .map(degree => (
                                                <option key={degree} value={degree}>
                                                    {degree}
                                                </option>
                                            ))}
                                    </Form.Select>
                                </Form.Group>

                                {/* <Form.Control
                                    readOnly
                                    value={form.pgDegrees.join(", ")}
                                    placeholder="Selected PG Degrees"
                                /> */}
                                {form.pgDegrees.length > 0 && (
                                    <div className="mt-2 d-flex flex-wrap gap-2">
                                        {form.pgDegrees.map((degree, index) => (
                                            <span
                                                key={index}
                                                className="badge bg-secondary d-flex align-items-center"
                                            >
                                                {degree}

                                                <button
                                                    type="button"
                                                    className="btn-close btn-close-white ms-2"
                                                    style={{ fontSize: "10px" }}
                                                    onClick={() =>
                                                        onChange({
                                                            target: {
                                                                name: "pgDegrees",
                                                                value: form.pgDegrees.filter(
                                                                    (_, i) => i !== index
                                                                ),
                                                            },
                                                        })
                                                    }
                                                />
                                            </span>
                                        ))}
                                    </div>
                                )}
                            </div>
                        )}

                        {/* Doctorate */}
                        <Form.Check
                            className="mb-2"
                            type="checkbox"
                            id="hasDoctorate"
                            label="Doctorate"
                            checked={form.hasDoctorate === "YES"}
                            onChange={(e) =>
                                onChange({
                                    target: {
                                        name: "hasDoctorate",
                                        value: e.target.checked ? "YES" : "NO",
                                    },
                                })
                            }
                        />

                        {form.hasDoctorate === "YES" && (
                            <div className="ms-4 mb-3">

                                <div className="d-flex gap-2">
                                    <Form.Control
                                        type="text"
                                        placeholder="Enter Doctorate Degree"
                                        value={doctorateInput}
                                        onChange={(e) => setDoctorateInput(e.target.value)}
                                    />

                                    <Button type="button"
                                        className="btn submit-job-btn"
                                        onClick={() => {
                                            const degree = doctorateInput.trim();

                                            if (
                                                degree &&
                                                !form.doctorates.includes(degree)
                                            ) {
                                                onChange({
                                                    target: {
                                                        name: "doctorates",
                                                        value: [...form.doctorates, degree],
                                                    },
                                                });

                                                setDoctorateInput("");
                                            }
                                        }}
                                    >
                                        Add
                                    </Button>
                                </div>

                                {form.doctorates.length > 0 && (
                                    <div className="mt-2 d-flex flex-wrap gap-2">
                                        {form.doctorates.map((degree, index) => (
                                            <span
                                                key={index}
                                                className="badge bg-secondary d-flex align-items-center"
                                            >
                                                {degree}

                                                <button
                                                    type="button"
                                                    className="btn-close btn-close-white ms-2"
                                                    style={{ fontSize: "10px" }}
                                                    onClick={() =>
                                                        onChange({
                                                            target: {
                                                                name: "doctorates",
                                                                value: form.doctorates.filter(
                                                                    (_, i) => i !== index
                                                                ),
                                                            },
                                                        })
                                                    }
                                                />
                                            </span>
                                        ))}
                                    </div>
                                )}
                            </div>
                        )}
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>
                            Job Description <span className="required-star">*</span>
                        </Form.Label>

                        <Form.Control
                            as="textarea"
                            rows={6}
                            name="description"
                            value={form.description}
                            onChange={onChange}
                        />
                    </Form.Group>

                </Modal.Body>

                <Modal.Footer className="post-job-modal-footer">

                    <button
                        type="button"
                        className="btn cancel-job-btn"
                        onClick={onClose}
                    >
                        Cancel
                    </button>

                    <button
                        type="submit"
                        className="btn submit-job-btn"
                        disabled={loading}
                    >
                        <FontAwesomeIcon
                            icon={buttonText === "Post Job" ? faPlus : faPen}
                            className="me-2"
                        />

                        {loading
                            ? buttonText === "Post Job"
                                ? "Posting..."
                                : "Updating..."
                            : buttonText}
                    </button>

                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default JobFormModal;
